var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-h"},[_c('div',{staticClass:"row full-h"},[_c('div',{staticClass:"column-center"},[_vm._t("header"),_vm._t("content")],2),_c('div',{staticClass:"column-right"},[_vm._t("tabs")],2)]),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }